import request from "../utils/request";
/* 
*   @czeqin
*/
// 新闻列表
export function newslist(data) {
      return request({
          url: "/news/list",
          method: "get",
          params: data,
      });
}
//新闻详情
export function newsdetail(data) {
      return request({
          url: "/news/queryById",
          method: "post",
          params: data,
      });
}
//品牌快讯列表
export function themelist(data) {
      return request({
          url: "/themeMarketing/list",
          method: "get",
          params: data,
      });
}
//招聘信息列表
export function recruitment(data) {
      return request({
          url: "/recruitment/query",
          method: "post",
          params: data,
      });
}
//招聘详情
export function recruitmentdetail(data) {
      return request({
          url: "/recruitment/queryById",
          method: "post",
          data: data,
      });
}
//门店列表
export function storeList(data) {
    return request({
        url: "/store/list",
        method: "post",
        data: data,
    });
}
// 门店查询
export function storequery(data) {
    return request({
        url: "/store/query",
        method: "post",
        data: data,
    });
}
// 简历保存
export function add(data) {
    return request({
        url: "/resume/add",
        method: "post",
        data: data,
    });
}
